import { AmountInput, RadioButton } from '@components';
import {
  AmountType,
  amountTypeOptions
} from '@features/transactions/constants';

type AmountTypeSelectorProps = {
  amountType: AmountType;
  onAmountTypeChange: (amountType: AmountType) => void;
  amount: string;
  onAmountChange: (amount: string) => void;
  errorMessage?: string;
  allowDecimals: boolean;
  showFullAmountOnly: boolean;
};

const AmountTypeSelector = ({
  amountType,
  onAmountTypeChange,
  amount,
  onAmountChange,
  errorMessage,
  allowDecimals,
  showFullAmountOnly
}: AmountTypeSelectorProps) => {
  const options = showFullAmountOnly
    ? amountTypeOptions.filter((option) => option.value === AmountType.FULL)
    : amountTypeOptions;

  return (
    <div className="flex flex-col gap-4">
      <div className="text-sm font-medium text-grey">
        Amount Paid <span className="text-error">*</span>
      </div>
      <div className="rounded-xl border">
        {options.map((option, index) => (
          <div
            key={`amount_type_${option.value}`}
            className={`mb-2 flex flex-col gap-2 p-3 ${
              index > 0 ? 'border-t' : ''
            }`}
          >
            <RadioButton
              isSelected={amountType === option.value}
              onChange={(e) => onAmountTypeChange(e.target.value as AmountType)}
              label={option.label}
              value={option.value}
              labelStyle="!text-content !text-base"
            />
            {amountType === AmountType.PARTIAL &&
              option.value === AmountType.PARTIAL && (
                <div className="ml-8">
                  <AmountInput
                    value={amount}
                    placeholder="Enter Amount"
                    onAmountChange={onAmountChange}
                    error={Boolean(errorMessage)}
                    errorMessage={errorMessage}
                    allowDecimals={allowDecimals}
                    className="!bg-white"
                  />
                </div>
              )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AmountTypeSelector;
